export const passportToggled = (person) => !!person?._passportToggle

export const bankInfoWithMaskedNumber = (bankInfo, allowFullyMasked = false) => {
  if (!bankInfo) return bankInfo

  const {
    accountAvailableBalance,
    accountHolderName,
    accountNickname,
    accountNumberLastFour,
    accountNumberLength,
    accountType,
    bankName,
    externalConnectionGuid,
    id,
    logoUrl,
    routingNumber,
    source,
  } = bankInfo
  const accountNumberMaskedString = accountNumberLength >= 4 ? '*'.repeat(accountNumberLength - 4) : ''
  const maskedAccountNumber = accountNumberLastFour
    ? `${accountNumberMaskedString}${accountNumberLastFour}`
    : allowFullyMasked
    ? '*'.repeat(10)
    : ''

  return {
    accountAvailableBalance,
    accountHolderName: accountHolderName ?? '',
    accountNickname,
    accountNumber: '',
    accountNumberDisplay: maskedAccountNumber,
    accountNumberLastFour: accountNumberLastFour ?? '',
    accountType,
    bankName: bankName ?? '',
    externalConnectionGuid: externalConnectionGuid ?? '',
    id,
    logoUrl: logoUrl ?? '',
    routingNumber: routingNumber ?? '',
    source,
  }
}

export const getEmptyCompanyOwner = () => ({
  _passportToggle: false,
  addressCity: '',
  addressCountryCode: 'US',
  addressPostalCode: '',
  addressState: '',
  addressStreet: '',
  addressStreetAdditional: '',
  dob: null,
  dobDisplay: '',
  email: '',
  firstName: '',
  id: '',
  isAuthorizedSigner: false,
  lastName: '',
  passportCountry: '',
  passportExpiration: null,
  passportNumber: '',
  passportNumberDisplay: '',
  phoneNumber: '',
  ssn: '',
  ssnDisplay: '',
  title: '',
})

export const removeNonNumericCharacters = (value) => {
  if (!value) {
    return value
  }
  return value?.replace(/\D+/g, '')
}

export const matchEmail = (email1, email2) => email1 && email2 && email1?.toLowerCase() === email2?.toLowerCase()
